import React from "react";
import { FaUserPlus } from "react-icons/fa";
import npcLogo from "../assets/npc/npc-logo.png";
import algonLogo from "../assets/npc/algon-logo.png";
import unicefLogo from "../assets/npc/unicef-logo.png";
import heroBg from "../assets/npc/Rectangle.png";

export default function Hero() {
  return (
    <div
      className="relative w-full flex items-center justify-center"
      style={{
        backgroundImage: `url('${heroBg}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "320px",
        paddingBottom: "80px",
      }}
    >
      <div className="absolute inset-0 bg-black opacity-20" />

      <div className="relative z-10 flex flex-col items-center text-center px-4 py-6 md:px-6 md:py-10 max-w-5xl w-full">
        {/* NPC logo */}
        <div className="flex items-center gap-2 mb-3">
          <img
            src={npcLogo}
            alt="National Population Commission"
            className="w-10 h-10 md:w-14 md:h-14 object-contain"
          />
          <div className="flex flex-col items-start text-white font-extrabold uppercase leading-none">
            <span className="text-[8px] md:text-[11px] tracking-wide">
              National Population
            </span>
            <span className="text-sm md:text-xl tracking-tight">
              Commission
            </span>
          </div>
        </div>

        {/* Logos */}
        <div className="relative flex items-center gap-1 mb-4">
          <img
            src={algonLogo}
            alt="ALGON"
            className="w-16 md:w-24 object-contain"
          />
          <div
            style={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-270%)",
              width: "3px",
              height: "20px",
              backgroundColor: "#3CFCAD",
              borderRadius: "30px",
            }}
          />
          <img
            src={unicefLogo}
            alt="UNICEF"
            className="w-16 md:w-24 object-contain"
          />
        </div>

        {/* Title row */}
        <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3 mb-2">
          <FaUserPlus
            className="text-2xl md:text-3xl"
            style={{ color: "#3CFCAD" }}
          />
          <h1
            className="text-lg md:text-2xl lg:text-4xl font-bold leading-tight"
            style={{ margin: 0, color: "#3CFCAD" }}
          >
            National Birth Registration Program
          </h1>
        </div>

        {/* Description */}
        <div
          className="text-xs md:text-sm lg:text-base flex items-center leading-relaxed mt-1 max-w-3xl font-normal"
          style={{ color: "#3CFCAD" }}
        >
          Securing every child’s legal identity through continuous, real-time
          vital statistics tracking and civil registration services nationwide.
        </div>
      </div>
    </div>
  );
}
